import { combineReducers } from 'redux';
import Users from './Users/reducer';
import Boxes from './Boxes/reducer';
import Environments from './Environments/reducer';
import Packs from './Packs/reducer';

export default combineReducers({
    Users,
    Boxes,
    Environments,
    Packs
});



// WEBPACK FOOTER //
// ./environments/testbench/data/reducer.js